import axios from "axios";
import { getHeaders } from "../utils/main";
import endpoints from "./endpoints";

export const getCityApi = async params => {
    const callResponse = await axios({
        url: endpoints.cityFetch,
        method: "get",
        headers: getHeaders(),
        params,
    })
        .then(response => response.data)
        .catch(err => ({ status: 0, response: err.response, code: err.response.status }));

    return callResponse;
};

export const CreateCityApi = async data => {
    const callResponse = await axios({
        url: endpoints.Createcity,
        method: "post",
        headers: getHeaders(),
        data,
    })
        .then(response => response.data)
        .catch(err => ({ status: 0, response: err.response, code: err.response.status }));

    return callResponse;
};

export const DeleteCityApi = async data => {
    const callResponse = await axios({
        url: endpoints.Deletecity,
        method: "delete",
        headers: getHeaders(),
        data,
    })
        .then(response => response.data)
        .catch(err => ({ status: 0, response: err.response, code: err.response.status }));

    return callResponse;
};

export const UpdateCityApi = async data => {
    const callResponse = await axios({
        url: endpoints.Updatecity,
        method: "patch",
        headers: getHeaders(),
        data,
    })
        .then(response => response.data)
        .catch(err => ({ status: 0, response: err.response, code: err.response.status }));

    return callResponse;
};

export const CityFindByIdApi = async params => {
    const callResponse = await axios({
        url: endpoints.cityById,
        method: "get",
        headers: getHeaders(),
        params,
    })
        .then(response => response.data)
        .catch(err => ({ status: 0, response: err.response, code: err.response.status }));

    return callResponse;
};